export const shopifyConfig = {
  domain: process.env.GATSBY_SHOPIFY_STORE_DOMAIN ?? '',
  apiVersion: '2024-10',
  get endpoint() {
    return `https://${this.domain}/api/${this.apiVersion}/graphql.json`;
  },
  storefrontToken: process.env.GATSBY_SHOPIFY_STOREFRONT_TOKEN ?? '',
} as const;

if (!shopifyConfig.domain || !shopifyConfig.storefrontToken) {
  // eslint-disable-next-line no-console
  console.warn(
    '[shopifyConfig] Missing GATSBY_SHOPIFY_STORE_DOMAIN or GATSBY_SHOPIFY_STOREFRONT_TOKEN environment variables.'
  );
}

